<template>
  <div class="app-footer">
    <div
      class="footer-item"
      style="position:relative;"
      :class="{'active':name=='home'}"
      @click.stop="BtnClick('home')"
    >
      <div>
        <img :src="name!='home'?home:homeActive" alt />
      </div>
      <p>首页</p>
    </div>
    <div class="footer-item" :class="{'active':name=='pay'}" @click.stop="BtnClick('pay')">
      <div>
        <img :src="name!='pay'?pay:payActive" alt />
      </div>
      <p>充值</p>
    </div>
      <div class="footer-item" :class="{'active':name=='shop'}" @click.stop="BtnClick('shop')">
      <div>
        <img :src="name!='shop'?shop:shopActive" alt />
      </div>
      <p>礼品</p>
    </div>
    <div
      style="position:relative;"
      class="footer-item"
      :class="{'active':name=='my'}"
      @click.stop="BtnClick('my')"
    >
      <div>
        <img :src="name!='my'?my:myActive" alt />
      </div>
      <p>我的</p>
    </div>
  </div>
</template>
<script>
import home from "../assets/icon/home.png";
import homeActive from "../assets/icon/home-active.png";
import pay from "../assets/icon/pay.png";
import payActive from "../assets/icon/pay-active.png";
import shop from "../assets/icon/shop.png";
import shopActive from "../assets/icon/shop-active.png";
import my from "../assets/icon/my.png";
import myActive from "../assets/icon/my-active.png";
import params from "../service/params";
import replaceState from "../util/replaceState";
export default {
  props: ["name"],
  data() {
    return {
      home: home,
      homeActive: homeActive,
      pay: pay,
      payActive: payActive,
      shop: shop,
      shopActive: shopActive,
      my: my,
      myActive: myActive
    };
  },
  methods: {
    BtnClick(name) {
      switch (name) {
        case "home":
          this.$router.push("/home");
          break;
        case "pay":
          this.$router.push("/pay/list");
          break;
        case "my":
          this.$router.push("/personal");
          break;
        case "shop":
        if (replaceState.isWeichat()) {
        window.location.href = params.WEB_SHOP_URL;
        } else if (replaceState.isYzl()) {
         window.location.href = params.SHOP_URL;
         }
          break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../sass/color";
.app-footer {
  width: 100%;
  height: 5rem;
  background-color: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  flex-flow: row;
  box-shadow: 0rem -0.3rem 0.8rem 0rem rgba(217, 224, 231, 0.67);
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 4.8rem;
  z-index: 1000;
  .footer-item {
    display: flex;
    flex-flow: column;
    align-items: center;
    font-size: 1.2rem;
    color: #bcc6d9;
    &.active {
      color: $main-color;
    }
  }
  img {
    width: 2.7rem;
    height: 2.7rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue